import styled, { css } from "styled-components";
import { MOSS_GREEN_800 } from "./colors";

const Container = styled.div`
  padding: ${({ padding }) => padding || "0.25rem"};
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      cursor: not-allowed;
    `}
`;

const Wrapper = styled.div`
  width: ${({ size }) => size || "1.5rem"};
  height: ${({ size }) => size || "1.5rem"};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 4rem;
  border: 1px solid ${MOSS_GREEN_800};
`;

const InnerCircle = styled.div`
  width: ${({ size }) => {
    const sizeValue = parseFloat(size || "1.5rem");
    return `${sizeValue * (16 / 24)}rem`;
  }};
  height: ${({ size }) => {
    const sizeValue = parseFloat(size || "1.5rem");
    return `${sizeValue * (16 / 24)}rem`;
  }};
  border-radius: 4rem;
  background-color: ${MOSS_GREEN_800};
`;

const Radio = ({ active, disabled, onClick, size = "1.5rem" }) => (
  //Container adds extra padding around it to ensure the minimum interactive target space is 32x32 pixels
  <Container disabled={disabled}>
    <Wrapper size={size} onClick={onClick}>{active && <InnerCircle size={size} />}</Wrapper>
  </Container>
);

export default Radio;
